import { createFileRoute } from '@tanstack/react-router';
import { areaRoute } from '../area-routes';
import { AreaView } from '../area-view';

export const Route = createFileRoute('/firm/$area')({
  ...areaRoute('/firm'),
  component: () => <AreaView base="/firm" />,
});
